export enum OfferTypeOptions {
  SPOT = 'ff8e664c-5f47-4613-8550-b694caa80407',
  LIST = 'd1504c75-3a0e-4b72-9054-2f5b9ec56a0b',
  ALL = '93ec31c4-c345-4631-86e0-8c6fdd8c1d53',
  REFRACTING = '2e93856b-63be-4ec3-a425-0a4b29e3eb8d',
}
